import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { DialogActionButtonProps } from "models/propTypes/menuPropTypes";
//#endregion
//#region components
import StyledButton from "./styledButton";
//#endregion

const DialogActionButton: React.FC<DialogActionButtonProps> = (props) => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const { actionDialog, reload, ...buttonProps } = props;

  const openActionDialog = actionDialog(reload);

  const onOpenActionDialogClick = () => {
    dispatch(displayDialog(openActionDialog));
  };

  return (
    <StyledButton {...buttonProps} onClick={onOpenActionDialogClick}>
      {props.children}
    </StyledButton>
  );
};

export default DialogActionButton;
